import React, { useEffect, useState, useRef } from 'react';
import Category from '../propertyEditPages/Category/Category';
import EditFileForm from '../propertyEditPages/EditForm/EditForm';
import './DocumentManager.css';
import upload from "./../../assets/Images/Request_Property/upload.png";
import { extractDateFromDocument, formatReadableDate } from '../../utils/dateExtractor';

import DateFormatDocs from '../propertyEditPages/DateFormatDocs/DateFormatDocs';
import { Button, Modal } from 'react-bootstrap';
import PropertiesService from '../../Services/PropertiesService';
import { FaEdit, FaLastfmSquare, FaTrashAlt } from 'react-icons/fa';
import * as pdfjsLib from "pdfjs-dist";
import { FaPlus } from "react-icons/fa";
import editIcon from "./../../assets/Images/edit (1).png";
import close from './../../assets/Images/Request_Property/close.png';
import loader from '../../assets/Images/Request_Property/Loader.gif';
import ScrollableTabs from '../ScrollableTabs/ScrollableTabs';
import { Edit } from 'lucide-react';
import { getDocumentPreviewUrl } from '../../utils/fileHelpers';
const DocumentManager = ({ documentsData, handleDocumentsUpdate, setdisplaySaveMessahes, setDateLoading, setDocumentsData }) => {
  const [switchFormat, setswitchFormat] = useState('Date')
  const inputRef = React.createRef();
  const [Error, setError] = useState('')
  const [active, setActive] = useState('left');
  const [documents, setDocuments] = useState(documentsData);
  const [editFileId, setEditFileId] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [CategoryName, setCategoryName] = useState(null);
  const [dateFormatEditModel, setdateFormatEditModel] = useState(false)
  const closeEditDateFormatModel = () => { setdateFormatEditModel(true) }
  const [EditDateFormatData, setEditDateFormatData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [EditDepartmentFormatData, setEditDepartmentFormatData] = useState([])
  const [loading, setloading] = useState(false)
  const fileInputRef = useRef(null);
  const fileInputRefeditcategoryformat = useRef(null);
  const fileInputRefeditregularFormat = useRef(null);
  const fileInputRefaddregularFormat22 = useRef(null);
  const fileInputRefforDateFormatAddDoc = useRef(null);
  const [text, setText] = useState("Upload a file to extract text.");
  const [manualDate, setManualDate] = useState("");
  const [EditLoading, setEditLoading] = useState(false);
  const [EditDocInRegularFormat, setEditDocInRegularFormat] = useState([]);

  const [newFileData, setNewFileData] = useState({
    name: "",
    file: "",
    size: 0,
    type: "application/pdf"
  });
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  const triggerFileInputForeditcategoryformat = () => {
    fileInputRefeditcategoryformat.current.click();
  };
  const onFileChange = (e, category, index) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      handleFiles(e, category, index);
    }
  };
  const validateField = (fieldName, value) => {
    // Default error is empty string (no error)
    let error = "";

    switch (fieldName) {
      case "type_of_document":
        if (!value.trim()) {
          error = "Document type is required";
        }
        break;
      case "department_of_registration_and_stamps":
        if (!value.trim()) {
          error = "Department name is required";
        }
        break;
      case "date_of_the_document_issued":
        if (!value) {
          error = "Date is required";
        } else {
          // Check if date is not in the future
          const selectedDate = new Date(value);
          const today = new Date().toISOString().split('T')[0];
          if (selectedDate > today) {
            error = "Date cannot be in the future";
          }
        }
        break;
      case "issued_by_officer_name":
        if (!value.trim()) {
          error = "Officer name is required";
        }
        break;
      case "officer_designation":
        if (!value.trim()) {
          error = "Officer designation is required";
        }
        break;
      case "office_situated_at":
        if (!value.trim()) {
          error = "Office location is required";
        }
        break;
      default:
        break;
    }

    return error;
  };
  const handleFiles = async (e, category, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    const tempFileId = `doc-${Date.now()}`;

    try {
      // Step 1: Show loader in fileInputs1
      setFileInputs1(prev => {
        const updatedCategoryFiles = [...(prev[category] || [])];
        updatedCategoryFiles[index] = {
          ...updatedCategoryFiles[index],
          loading: true,
        };
        return {
          ...prev,
          [category]: updatedCategoryFiles,
        };
      });

      // // Step 2: Add a placeholder to Documents with loader=true
      // setDocuments(prev => {
      //   const existing = prev?.files?.[category] || [];
      //   return {
      //     ...prev,
      //     files: {
      //       ...prev.files,
      //       [category]: [
      //         ...existing,
      //         {
      //           id: tempFileId,
      //           file: URL.createObjectURL(file),
      //           loading: true,
      //           name: file.name,
      //           type: file.type,
      //           size: file.size,
      //         },
      //       ],
      //     },
      //   };
      // });

      // Step 3: Upload the file to server
      const response = await PropertiesService.UploadFiles(formData);

      // Step 4: Update FileInputs1 after upload
      setFileInputs1(prev => {
        const updatedCategoryFiles = [...(prev[category] || [])];
        updatedCategoryFiles[index] = {
          ...updatedCategoryFiles[index],
          id: tempFileId,
          name: file.name,
          type: file.type,
          size: file.size,
          file: response?.Location || "",
          loading: false,
        };
        return {
          ...prev,
          [category]: updatedCategoryFiles,
        };
      });

      // // Step 5: Update loader=false in Documents list
      // setDocuments(prev => {
      //   const existing = prev?.files?.[category] || [];
      //   const updated = existing.map(doc =>
      //     doc.id === tempFileId ? { ...doc, file: response?.Location, loading: false } : doc
      //   );
      //   return {
      //     ...prev,
      //     files: {
      //       ...prev.files,
      //       [category]: updated,
      //     },
      //   };
      // });

    } catch (error) {
      console.error("Error uploading file:", error);

      // Set loader to false on error
      setFileInputs1(prev => {
        const updatedCategoryFiles = [...(prev[category] || [])];
        updatedCategoryFiles[index] = {
          ...updatedCategoryFiles[index],
          loading: false,
        };
        return {
          ...prev,
          [category]: updatedCategoryFiles,
        };
      });

      // // Optional: update document list with error state or remove the failed upload
      // setDocuments(prev => {
      //   const updatedDocs = (prev?.files?.[category] || []).filter(doc => doc.id !== tempFileId);
      //   return {
      //     ...prev,
      //     files: {
      //       ...prev.files,
      //       [category]: updatedDocs,
      //     },
      //   };
      // });
    }
  };


  const handleFieldChange = (category, index, fieldName, value) => {
    // Step 1: Set loading = true (optional for fields, but kept consistent)
    setFileInputs1((prevState) => {
      const updatedCategoryFiles = [...(prevState[category] || [])];
      const entry = { ...(updatedCategoryFiles[index] || {}) };
      entry.loading = true;
      updatedCategoryFiles[index] = entry;
      return { ...prevState, [category]: updatedCategoryFiles };
    });

    // Step 2: Build updated fileInputs1 manually
    const updated = (prev) => {
      const updatedCategoryFiles = [...(prev[category] || [])];
      const oldEntry = updatedCategoryFiles[index] || {};

      updatedCategoryFiles[index] = {
        ...oldEntry,
        fields: {
          ...(oldEntry.fields || {}),
          [fieldName]: value,
        },
        loading: false, // clear loading once update is done
      };

      return {
        ...prev,
        [category]: updatedCategoryFiles,
      };
    };
    // Step 2: Add a placeholder to Documents with loader=true

    // Step 3: Update fileInputs1
    setFileInputs1((prev) => {
      const updatedInputs = updated(prev);
      return updatedInputs;
    });
  };
  // department wise functions start
  const handleDeleteFile = (category, fileId) => {
    setDocuments(prevState => {
      const updatedFiles = prevState.files[category].filter(file => file.id !== fileId);
      const updatedDocuments = {
        ...prevState,
        files: {
          ...prevState.files,
          [category]: updatedFiles
        }
      };



      return updatedDocuments;
    });
  };
  const handleAddFile = async (category, file) => {
    setDocuments(prevState => {
      const updatedDocuments = {
        ...prevState,
        files: {
          ...prevState.files,
          [category]: [...prevState.files[category], file]
        }
      };


      return updatedDocuments;
    });
  }
  const handleEditFile = async (data, category) => {
    setCategoryName(category)


    setEditDepartmentFormatData(data)
    triggerFileInputForeditcategoryformat()
  };
  const handleUploadDepartmentFormatEditFile = async (e) => {
    setDocuments(prevState => {
      const updatedDocuments = prevState.files[CategoryName].map(doc =>
        doc.id === EditDepartmentFormatData.id
          ? { ...doc, file: doc.file, name: doc.name, size: doc.size, type: doc.type, loading: true }
          : doc
      );
      return {
        ...prevState,
        files: {
          ...prevState.files,
          [CategoryName]: updatedDocuments
        }
      };
    });
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    setloading(true);
    setDateLoading(true)
    try {
      const response = await PropertiesService.UploadFiles(formData);
      setDocuments((prevState) => {
        const documentToEdit = prevState.files[CategoryName]?.find(doc => doc.id === EditDepartmentFormatData.id);

        if (!documentToEdit) {
          console.warn("Document not found for editing.");
          return prevState;
        }

        const updatedDocuments = prevState.files[CategoryName].map(doc =>
          doc.id === EditDepartmentFormatData.id
            ? { ...doc, file: response.Location, name: file.name, size: file.size, type: file.type, loading: false }
            : doc
        );

        return {
          ...prevState,
          files: {
            ...prevState.files,
            [CategoryName]: updatedDocuments
          }
        };
      });

      setdateFormatEditModel(false);
    } catch (error) {
      console.error('Error uploading and editing file:', error);
    } finally {
      setDateLoading(false)
      setloading(false);
    }
  };
  // department wise functions end


  // date format functions start
  const handleDeleteDatefORMATFile = (fileId) => {
    setDocuments(prevState => {
      const updatedDocuments = prevState.date.filter((doc) => doc.id !== fileId);
      return { date: updatedDocuments };
    });
  };
  const handleDateFormatData = (data) => {
    setEditDateFormatData(data)
    triggerFileInput()
  }
  const handleUploadDateFormatEditFile = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('image', file);
    setloading(true)
    try {
      const response = await PropertiesService.UploadFiles(formData);
      const documentToEdit = documents.date.find(doc => doc.id === EditDateFormatData.id);
      if (documentToEdit) {
        const updatedDocument = {
          ...documentToEdit,
          manualDate: new Date().toISOString().split('T')[0],
          data: response.Location,
        };
        setDocuments(prevState => {
          const updatedDate = prevState.date.map(doc =>
            doc.id === EditDateFormatData.id ? updatedDocument : doc
          );
          return {
            ...prevState,
            date: updatedDate
          };
        });
        setdateFormatEditModel(false);
        setloading(false)
      }
    } catch (error) {
      console.error('Error uploading and editing file:', error);
    }
  };
  const handleManualDateChange = (e, id) => {
    const newDate = e.target.value;
    setDocuments((prevDocuments) => ({
      ...prevDocuments,
      date: prevDocuments.date.map((doc) =>
        doc.id === id ? { ...doc, manualDate: newDate } : doc
      ),
    }));
  };
  const handleDeclareDate = (type, e, id) => {
    const newDate = e.target.value;
    setDocuments((prevDocuments) => ({
      ...prevDocuments,
      date: prevDocuments.date.map((doc) =>
        doc.id === id ? { ...doc, declare: type === "declare" ? newDate : doc.declare, } : doc
      ),
    }));
  };
  const handleDateFormatFileChange = async (e) => {
    setloading(true);
    setDateLoading(true);
    const file = e.target.files[0];
    if (!file) {
      setloading(false);
      setDateLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await PropertiesService.UploadFiles(formData);
      const data = response.Location;

      const docId = `input-${documents.date.length === 0 ? 1 : documents.date.length + 1}`;
      const newDocument = {
        id: docId,
        data,
        manualDate: '',
        isExtracting: true,
      };

      setDocuments(prevState => ({
        ...prevState,
        date: prevState.date ? [...prevState.date, newDocument] : [newDocument],
      }));

      setloading(false);
      setDateLoading(false);

      // Perform OCR asynchronously
      try {
        const { date } = await extractDateFromDocument(file, pdfjsLib);
        setDocuments(prevState => ({
          ...prevState,
          date: prevState.date.map(doc =>
            doc.id === docId ? { ...doc, manualDate: date, declare: !!date, isExtracting: false } : doc
          )
        }));
      } catch (ocrErr) {
        console.error('OCR Error:', ocrErr);
        setDocuments(prevState => ({
          ...prevState,
          date: prevState.date.map(doc =>
            doc.id === docId ? { ...doc, isExtracting: false } : doc
          )
        }));
      }

    } catch (error) {
      console.error('Error uploading file:', error);
      alert('There was an error uploading the file.');
      setloading(false);
      setDateLoading(false);
    }
  };
  const extractTextFromTXT = (file) => {
    const reader = new FileReader();
    reader.readAsText(file);

    reader.onload = () => {
      const extractedText = reader.result;
      setText(extractedText);
      extractData(extractedText);
    };

    reader.onerror = () => {
      setText("Error reading file.");
    };
  };
  const extractTextFromPDF = async (file) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async () => {
      const pdfData = new Uint8Array(reader.result);
      const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
      let extractedText = "";
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map((item) => item.str).join(" ");
        extractedText += pageText + "\n";
      }
      setText(extractedText);
      extractData(extractedText);
    };
    reader.onerror = () => {
      setText("Error reading PDF file.");
    };
  };
  const extractData = (text) => {
    const meetingDatePattern = /Date:\s*(\d{2}:\d{2}:\d{4})/g;
    const foundMeetingDates = [];
    let match;

    while ((match = meetingDatePattern.exec(text)) !== null) {
      foundMeetingDates.push(match[1]);
    }
    if (foundMeetingDates.length > 0) {
      setManualDate(foundMeetingDates[0])
    }

  };
  const openUploadForDateFormatAddDoc = () => {
    fileInputRefforDateFormatAddDoc.current.click();
  }
  // date format functions end

  // regular format functions start
  const onEditRegularFormatDoc = async (e) => {
    setEditLoading(true)
    setDateLoading(true)
    const documentToEdit = documents.files?.[EditDocInRegularFormat.category].find(doc => doc.id === EditDocInRegularFormat.file.id);
    const updatedDocument = {
      ...documentToEdit,
    };
    setDocuments(prevState => ({
      ...prevState,
      files: {
        ...prevState.files,
        [EditDocInRegularFormat.category]: prevState.files?.[EditDocInRegularFormat.category].map(doc =>
          doc.id === EditDocInRegularFormat.file.id ? updatedDocument : doc
        ),
      },
    }));
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('image', file);
    try {
      const response = await PropertiesService.UploadFiles(formData);
      if (response.message == 'Success') {
        if (documentToEdit) {
          const updatedDocument = {
            ...documentToEdit,
            data: response.Location,
          };
          setDocuments(prevState => ({
            ...prevState,
            files: {
              ...prevState.files,
              [EditDocInRegularFormat.category]: prevState.files?.[EditDocInRegularFormat.category].map(doc =>
                doc.id === EditDocInRegularFormat.file.id ? updatedDocument : doc
              ),
            },
          }));
          setEditLoading(false)
          setDateLoading(false)
        }
      } else {
        setEditLoading(false)
        setDateLoading(false)
        const updatedDocument = {
          ...documentToEdit,
        };
        setDocuments(prevState => ({
          ...prevState,
          files: {
            ...prevState.files,
            [EditDocInRegularFormat.category]: prevState.files?.[EditDocInRegularFormat.category].map(doc =>
              doc.id === EditDocInRegularFormat.file.id ? updatedDocument : doc
            ),
          },
        }));
      }
    } catch {
      setEditLoading(false)
      setDateLoading(false)
    }

  }
  const OpenRegularFormatDocUpload = (file, category) => {
    let obj = {
      file: file || '',
      category: category || ''
    }
    setEditDocInRegularFormat(obj)
    fileInputRefeditregularFormat.current.click();
  }
  const OpenAddRegularFormatDocUpload = (category) => {
    let obj = {
      category: category || ''
    }
    setEditDocInRegularFormat(obj)
    fileInputRefaddregularFormat22.current.click();
  }
  const handleAddRegularFormat = async (e) => {
    setIsLoading(true)
    setDateLoading(true)
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('image', file);
    try {
      const response = await PropertiesService.UploadFiles(formData);
      const data = response.Location;
      const newDocument = {
        id: `input-${documents.files?.[EditDocInRegularFormat.category]?.length ? documents.files[EditDocInRegularFormat.category].length + 1 : 1}`,
        data,
      };
      setDocuments(prevState => ({
        ...prevState,
        files: {
          ...prevState.files,
          [EditDocInRegularFormat.category]: [
            ...(prevState.files?.[EditDocInRegularFormat.category] || []),
            newDocument
          ],
        },
      }));
      setIsLoading(false)
      setDateLoading(false)
    } catch (error) {
      console.error('Error uploading file:', error);
      setIsLoading(false)
      setDateLoading(false)
      alert('There was an error uploading the file.');
    } finally {
      setIsLoading(false)
      setDateLoading(false)
    }
  };
  const onDeleteRegularFormatDocumentsFiles = (category, id) => {
    setDocuments(prevState => ({
      ...prevState,
      files: {
        ...prevState.files,
        [category]: prevState.files?.[category].filter(doc => doc.id !== id),
      },
    }));
  };
  const [selectedTab, setSelectedTab] = useState(null);
  useEffect(() => {
    if (!selectedTab && documents?.files) {
      const firstCategory = Object.keys(documents.files)[0];
      setSelectedTab(firstCategory);
    }
  }, [documents]);
  // regular format functions end
  useEffect(() => {
    handleDocumentsUpdate(documents)
    setDocumentsData(documents)
  }, [documents]);
  const scrollRef = useRef(null);
  const scrollAmount = 200;
  const [fileInputs1, setFileInputs1] = useState({
    Category_1: [],
  });

  const [displayAddDocsUi, setdisplayAddDocsUi] = useState(false)
  const [translate, setTranslate] = useState(0)
  const [isLeftVisible, setIsLeftVisible] = useState(false)
  const [isRightVisible, setIsRightVisible] = useState(false)
  const [textInputs, setTextInputs] = useState({
    Category_1: "",
  });
  const [categories1, setCategories1] = useState(["Category_1"]);
  const containerRef = useRef < HTMLDivElement > (null)
  const files = categories1[selectedTab] || [];
  const handleClick = (inputRef) => {
    if (inputRef) inputRef.click();
  };
  const removeFileInput1 = (category, index) => {
    setFileInputs1((prevFileInputs) => {
      if (prevFileInputs[category] && prevFileInputs[category].length > 0) {
        const updatedCategoryFiles = prevFileInputs[category].filter(
          (_, i) => i !== index
        );
        return {
          [category]: updatedCategoryFiles,
        };
      }
      return prevFileInputs;
    });
  };

  const handleFileChange = (category, event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const newFile = {
      id: Math.random().toString(36).substr(2, 9),
      file: URL.createObjectURL(file),
      loading: true,
      fields: {
        name: file.name,
        type: file.type,
        size: file.size
      }
    };

    setDocuments(prev => ({
      ...prev,
      files: {
        ...prev.files,
        [category]: [newFile]
      }
    }));
  };
  const handleOpenAddDepartmentDataModel = (selectedData) => {
    setdisplayAddDocsUi(true)
    // setCategories1(selectedData?.files)
    console.log(selectedData?.files, files, 'selectedData')
  }
  const addFileInput1 = (category) => {
    console.log(category, 'categorysss')
    if (!category) return;
    setdisplayAddDocsUi(true)
    setFileInputs1((prevInputs) => {
      const existingFiles = (prevInputs?.[category]) || [];
      const newFile = {
        id: `doc-${Date.now()}`,
        file: null,
        ref: null,
        loading: false,
        fields: {}
      };
      return {
        ...prevInputs,
        [category]: [...existingFiles, newFile]
      };
    });
  };
  useEffect(() => {
    if (containerRef.current == null) return

    const observer = new ResizeObserver(entries => {
      const container = entries[0]?.target
      if (container == null) return

      setIsLeftVisible(translate > 0)
      setIsRightVisible(
        translate + container.clientWidth < container.scrollWidth
      )
    })

    observer.observe(containerRef.current)

    return () => {
      observer.disconnect()
    }
  }, [documents.files, translate])
  const safeTab = selectedTab || 'defaultCategory';
  useEffect(() => {
  }, 2000)
  const handleFieldsDataUpload = () => {
    let isValid = true;
    let errorMessage = "";
    Object.entries(fileInputs1).forEach(([category, newDocs]) => {
      if (!Array.isArray(newDocs)) return;

      newDocs.forEach((newDoc, index) => {
        if (!newDoc.file || newDoc.file === "") {
          isValid = false;
          errorMessage = `File missing in (document #${index + 1})`;
          return;
        }
        const requiredFields = [
          "typeofdocument",
          "departmentofregistrationandstamps",
          "datethedocumentwasissued",
          "nameofissuingofficer",
          "designationofofficer",
          "officesituatedat"
        ];

        for (let field of requiredFields) {
          if (!newDoc.fields?.[field] || newDoc.fields[field].trim() === "") {
            isValid = false;
            errorMessage = `Field "${field}" is missing in  (document #${index + 1})`;
            return;
          }
        }
      });
    });

    if (!isValid) {
      setError(errorMessage)
      setTimeout(() => {
        setError('')
      }, 2000)
      return;
    }

    setdisplayAddDocsUi(false);
    setdisplaySaveMessahes(true);

    setDocuments(prev => {
      const updatedFiles = { ...prev.files };

      Object.entries(fileInputs1).forEach(([category, newDocs]) => {
        if (!Array.isArray(newDocs)) return;

        const existingDocs = updatedFiles[category] || [];
        const mergedDocs = [...existingDocs];

        newDocs.forEach(newDoc => {
          if (!newDoc || !newDoc.id) return;

          const existingIndex = existingDocs.findIndex(doc => doc.id === newDoc.id);

          if (existingIndex === -1) {
            mergedDocs.push(newDoc);
          } else {
            mergedDocs[existingIndex] = {
              ...existingDocs[existingIndex],
              ...newDoc,
              fields: {
                ...existingDocs[existingIndex].fields,
                ...newDoc.fields,
              }
            };
          }
        });

        updatedFiles[category] = mergedDocs;
      });

      return {
        ...prev,
        files: updatedFiles,
      };
    });

    console.log(fileInputs1, "fileInputs1");
  };

  const handleshowUploadDocs = () => {
    setdisplayAddDocsUi(true)
    setdisplaySaveMessahes(false)
    console.log(fileInputs1, 'fileInputs1')
  }
  return (
    <>
      {displayAddDocsUi && documents?.categories && <div className="row setspacebetween">

        <div className="col-md-3 setStartTheText">
          <button
            className="tab-button active"
            disabled={isLoading}
            onClick={() => addFileInput1(selectedTab)}>
            <span>Add Document</span>
          </button>
        </div>
        <div className="col-md-3 setEndTheText">

          <button
            className="tab-button active"
            disabled={isLoading}
            onClick={() => handleFieldsDataUpload()}>
            <span>Save Data</span>
          </button>
        </div>
      </div>
      }
      <div className="document-manager">
        <div className="row kyp-card-row">
          {documents?.regularcategories && (
            <>
              <div className="row">
                <div className="col-md-12">
                  {/* Tabs */}
                  <ScrollableTabs
                    categories={documents.files}
                    documentsType='files'
                    selectedCategory={selectedTab}
                    onSelect={(cat) => setSelectedTab(cat)}
                  />
                </div>

              </div>
              <div className="row justify-content-end">
                <div className="col-md-2 ">
                  <button
                    className="tab-button active"
                    disabled={isLoading}
                    onClick={(e) => {
                      e.stopPropagation();
                      OpenAddRegularFormatDocUpload(selectedTab);
                    }}
                  >   {isLoading && EditDocInRegularFormat.category === selectedTab ? (
                    <img src={loader} style={{ width: '20px' }} />
                  ) : (
                    <span>Add Document</span>
                  )}
                  </button>
                </div>
              </div>

              {/* Only Selected Tab's Documents */}
              {selectedTab && documents?.files[selectedTab] && (
                <div className="regularformat-card">
                  {/* <div className="row">
                    <div className="col-md-3">
                      <div className="fab-button">
                        {isLoading && EditDocInRegularFormat.category === selectedTab ? (
                          <img src={loader} style={{ width: '40px' }} />
                        ) : (
                          <FaPlus
                            onClick={(e) => {
                              e.stopPropagation();
                              OpenAddRegularFormatDocUpload(selectedTab);
                            }}
                            disabled={isLoading}
                            size={20}
                          />
                        )}
                      </div>
                    </div>
                  </div> */}
                  {/* Hidden File Inputs */}
                  <input
                    type="file"
                    name="file"
                    ref={fileInputRefaddregularFormat22}
                    style={{ display: 'none' }}
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.csv,.svg"
                    onChange={handleAddRegularFormat}
                  />
                  <input
                    type="file"
                    name="file"
                    ref={fileInputRefeditregularFormat}
                    style={{ display: 'none' }}
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.csv,.svg"
                    onChange={onEditRegularFormatDoc}
                  />
                  {/* File Cards */}
                  <div className={documents.files[selectedTab].length === 1 ? "row justify-content-center" : "row justify-content-start"}>
                    {documents.files[selectedTab].length > 0 ? (
                      documents.files[selectedTab].map((file, idx) => (
                        <div key={idx} className="col-md-3 mb-3">
                          {EditLoading && EditDocInRegularFormat.file.id === file.id ? (
                            <>
                              <img src={loader} style={{ width: '40px', marginLeft: '80px' }} />
                            </>
                          ) : (
                            <div className="file-container" style={{ position: 'relative' }}>
                              <div
                                className="file-actions"
                                style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}
                              >
                                <img
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    OpenRegularFormatDocUpload(file, selectedTab);
                                  }}
                                  src={editIcon}
                                  className="editIcon"
                                />
                                <div
                                  className="file-remove-button221"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onDeleteRegularFormatDocumentsFiles(selectedTab, file.id);
                                  }}
                                >
                                  <span className="x-icon" style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '14px' }}>✕</span>
                                </div>
                              </div>
                              <iframe
                                src={getDocumentPreviewUrl(file.data)}
                                width="100%"
                                height="80%"
                                style={{ border: 'none', height: '100px' }}
                                title="Document Viewer"
                              />
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="col-md-12">No {selectedTab.replace(/_/g, ' ')} Documents Uploaded</div>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
          {/* date format */}
          {documents?.date ? <>
            <div className="row justify-content-end">
              <div className="col-md-3 setEndTheText">
                <div className="add-file-container">
                  <input
                    ref={fileInputRefforDateFormatAddDoc}
                    type="file"
                    onChange={handleDateFormatFileChange}
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                    style={{ display: 'none' }}

                  />
                  <button onClick={openUploadForDateFormatAddDoc} className='btn uploadButton mt-1'
                    disabled={loading ? true : false} >
                    {loading ? 'Uploading....' : 'Add New Document'}
                  </button>
                </div>
              </div>

            </div>
            <div className={documents?.date && documents?.date.length === 1 ? "row justify-content-center" : "row justify-content-start"}>
              {documents?.date.length > 0 ?
                documents?.date.map((document) => (

                  <div key={document.id} className="col-md-3">
                    <div className="file-container" style={{ position: 'relative' }}>
                      <div className="file-actions" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>

                        <img onClick={(e) => {
                          e.stopPropagation();
                          handleDateFormatData(document);
                        }} src={editIcon} className="editIcon" />
                        <div
                          className="file-remove-button221"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteDatefORMATFile(document.id);
                          }}
                        >
                          <span className="x-icon" style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '14px' }}>✕</span>
                        </div>
                      </div>

                      <iframe
                        src={getDocumentPreviewUrl(document.data)}
                        width="100%"
                        height="80%"
                        style={{ border: 'none' }}
                        title="Document Viewer"
                      />

                    </div>
                    <div className="date-selection-box mt-2 p-2 border rounded bg-light">
                      {document.isExtracting ? (
                        <div className="d-flex align-items-center gap-2">
                          <span className="spinner-border spinner-border-sm text-primary" role="status"></span>
                          <span style={{ fontSize: '12px', fontWeight: '600', color: 'var(--color-turquoise-teal)' }}>Reading document date... please wait...</span>
                        </div>
                      ) : (
                        <>
                          {document.allDates && document.allDates.length > 0 && (
                            <div className="mb-2 text-start">
                              <label style={{ fontSize: '12px', fontWeight: '600', color: '#333', display: 'block', marginBottom: '4px' }}>
                                📅 Detected Document Dates:
                              </label>
                              <div className="d-flex flex-wrap gap-1 mb-2">
                                {document.allDates.map((item, index) => {
                                  const isSelected = document.manualDate === item.normalized && document.selectedMode !== 'manual';
                                  return (
                                    <button
                                      key={index}
                                      type="button"
                                      onClick={() => {
                                        setDocuments(prevState => ({
                                          ...prevState,
                                          date: prevState.date.map(doc =>
                                            doc.id === document.id ? { 
                                              ...doc, 
                                              manualDate: item.normalized, 
                                              declare: true, 
                                              selectedMode: 'extracted' 
                                            } : doc
                                          )
                                        }));
                                      }}
                                      className={`btn btn-sm ${isSelected ? 'btn-primary' : 'btn-outline-primary'}`}
                                      style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '12px' }}
                                    >
                                      {formatReadableDate(item.normalized)} {item.page ? `(Pg ${item.page})` : ''}
                                    </button>
                                  );
                                })}
                                <button
                                  type="button"
                                  onClick={() => {
                                    setDocuments(prevState => ({
                                      ...prevState,
                                      date: prevState.date.map(doc =>
                                        doc.id === document.id ? { ...doc, selectedMode: 'manual' } : doc
                                      )
                                    }));
                                  }}
                                  className={`btn btn-sm ${document.selectedMode === 'manual' ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                  style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '12px' }}
                                >
                                  ✏️ Enter Manually
                                </button>
                              </div>
                            </div>
                          )}

                          {(document.selectedMode === 'manual' || !document.allDates || document.allDates.length === 0) && (
                            <div className="mb-2 text-start">
                              <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>
                                Enter Date Manually:
                              </label>
                              <input
                                type="date"
                                className="form-control mb-1"
                                value={document.manualDate || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const parts = value.split("-");
                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                  handleManualDateChange(e, document.id);
                                }}
                              />
                            </div>
                          )}

                          {document.manualDate && (
                            <div className="mt-1">
                              <p style={{ fontSize: '12px', color: 'var(--color-turquoise-teal)', fontWeight: '600', marginTop: '4px', marginBottom: '4px', textAlign: 'center' }}>
                                Auto-read Date: {formatReadableDate(document.manualDate)} ({document.manualDate})
                              </p>
                              <p style={{ marginTop: "6px", marginBottom: "0", fontSize: "12px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                                <span style={{ color: "var(--color-turquoise-teal)", fontWeight: "500" }}>
                                  I confirm this date is correct{" "}
                                </span>
                                <input
                                  type="checkbox"
                                  checked={document.declare || false}
                                  style={{ cursor: "pointer", width: "15px", height: "15px", accentColor: "var(--color-turquoise-teal)" }}
                                  onChange={(e) => {
                                    handleDeclareDate("declare", e, document.id);
                                  }}
                                />
                              </p>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                ))
                : <div className="col-md-12">No Documents Uploaded</div>
              }
            </div>

            <input
              type="file"
              name="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
              onChange={handleUploadDateFormatEditFile}
              placeholder="Enter new file URL"
            />
            {/* <input type='submit' onClick={() => handleDocumentsUpdate(documents)} /> */}
          </> : ''}
          {/* department format */}
          {documents?.categories ? <>
            <div className="row justify-content-start">
              <div className="col-md-10">
                {!displayAddDocsUi && <ScrollableTabs
                  categories={documents?.descriptions}
                  documentsType='descriptions'
                  selectedCategory={selectedTab}
                  onSelect={(cat) => setSelectedTab(cat)}
                />}
              </div>
              <div className="col-md-2 ">
                {!displayAddDocsUi && <button
                  className="tab-button active"
                  disabled={isLoading}
                  onClick={() => handleshowUploadDocs(true)}>
                  <span>Add Document</span>
                </button>}
              </div>
            </div>
            {displayAddDocsUi ?
              <>
                {fileInputs1[selectedTab].length > 0 ?
                  <div className="row justify-content-start">
                    <p className='error'>{Error}</p>
                    {fileInputs1[selectedTab]?.map((file, docIndex) => (
                      <div className="col-lg-6 col-12" key={file.id || docIndex} >
                        <div className="document-card">
                          <div className="row justify-content-end">
                            <div className="col-md-2">
                              <p
                                className="doc-remove-btn"
                                onClick={() => removeFileInput1(selectedTab, docIndex)}
                              >
                                ✕
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-5 col-md-6 col-12">
                              <div className="upload-section">
                                {file.loading ? (
                                  <div className="loader-container">
                                    <img src={loader} alt="Loading..." />
                                    <p>Uploading...</p>
                                  </div>
                                ) : file.file ? (
                                  <iframe
                                    src={getDocumentPreviewUrl(file.file)}
                                    title="Document Preview"
                                    className="displayUploadedFile"
                                    style={{ width: "100%", height: "280px", border: "none" }}
                                  />
                                ) : (
                                  <div className="upload-placeholder" onClick={() => handleClick(file.ref)}>
                                    <img src={upload} alt="Upload" width={40} />
                                    <p>Click to Upload</p>
                                  </div>
                                )}
                                <input
                                  type="file"
                                  style={{ display: "none" }}
                                  ref={(el) => (file.ref = el)}
                                  accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.csv,.svg"
                                  onChange={(e) => onFileChange(e, selectedTab, docIndex)}
                                />
                                {validationErrors[selectedTab]?.[docIndex]?.fileUpload && (
                                  <p className="error-text">{validationErrors[selectedTab][docIndex].fileUpload}</p>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-7 col-md-6 col-12">
                              <div className="fields-section row">
                                {[
                                  "Type Of Document",
                                  "Department of Registration and Stamps",
                                  "Date the Document was Issued",
                                  "Name of Issuing Officer",
                                  "Designation of Officer",
                                  "Office Situated At",
                                ].map((label, i) => {
                                  const fieldKey = label.replace(/[^a-zA-Z0-9]/g, "").toLowerCase().replace(/\s+/g, "_");
                                  const value = fileInputs1[selectedTab]?.[docIndex]?.fields?.[fieldKey] || "";
                                  const error = validationErrors[selectedTab]?.[docIndex]?.[fieldKey] || "";
                                  return (
                                    <div key={`field-${docIndex}-${i}`} className="col-md-6 col-12 mb-3 form-group mainData">
                                      <label className='form-label labelStyles'>{label}</label>
                                      <input
                                        type={label.includes("Date") ? "date" : "text"}
                                        placeholder={label}
                                        className={`form-control ${error ? "error" : ""}`}
                                        value={value}
                                        onChange={(e) => {
                                          let val = e.target.value;
                                          if (label.includes("Date")) {
                                            const parts = val.split("-");
                                            if (parts[0]?.length > 4) {
                                              parts[0] = parts[0].slice(0, 4);
                                              val = parts.join("-");
                                            }
                                          }
                                          handleFieldChange(selectedTab, docIndex, fieldKey, val);
                                        }}
                                        onBlur={(e) => {
                                          const error = validateField(fieldKey, e.target.value);
                                          setValidationErrors((prev) => {
                                            const updated = { ...prev };
                                            if (!updated[selectedTab]) updated[selectedTab] = {};
                                            if (!updated[selectedTab][docIndex]) updated[selectedTab][docIndex] = {};
                                            updated[selectedTab][docIndex][fieldKey] = error;
                                            return updated;
                                          });
                                        }}
                                      />
                                      {error && <p className="error-text">{error}</p>}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div> : <div className="d-flex flex-column align-items-center justify-content-center text-center p-5 bg-light rounded-4 border border-dashed">
                    <i className="fas fa-folder-open fa-3x text-muted mb-3"></i>
                    <h5 className="text-muted">No documents added yet</h5>
                    <p className="text-secondary small mb-3">Start by uploading a document related to this category.</p>
                    <button className="btn uploadDocButton" onClick={() => addFileInput1(selectedTab)}>
                      <i className="uploadDocButton"></i>Upload Document
                    </button>
                  </div>
                }
              </>
              : <div className="col-md-12" >
                <Category
                  category={selectedTab}
                  description={documents?.descriptions[selectedTab]}
                  files={documents?.files?.[safeTab] || []}
                  onDeleteFile={handleDeleteFile}
                  onEditFile={handleEditFile}
                  onAddFile={handleAddFile}
                />
                <input
                  type="file"
                  name="file"
                  ref={fileInputRefeditcategoryformat}
                  style={{ display: 'none' }}
                  onChange={handleUploadDepartmentFormatEditFile}
                  placeholder="Enter new file URL"
                />
              </div>
            }
          </> : ''}
        </div>
      </div>
    </>
  );
};


export default DocumentManager;

